import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { MxSliderComponent } from './mx.slider.component';

export const COMPONENTS: any[] = [MxSliderComponent];

@NgModule({
  imports: [CommonModule, PrimengModule, FormsModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class MxSliderModule {}
